import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  editClinicTestMasterTestByTestId,
  getClinicTestMasterTestDetailsByTestId,
  getClinicTestMasterByClinicId,
  resetDeleteTestinClinicTestMasterMessage,
  deleteTestFromClinicTestMaster,
  resetEditClinicTestMasterTestByTestIdMessage,
  setCurrentPage,
  setPageLimit,
} from "../../../store/slices/clinicTestMaster";
import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import classNames from "classnames";
import styles from "../clinicLabProfile/clinicLabProfile.module.scss";
import { RiProfileLine } from "react-icons/ri";
import { FaChevronRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import ViewTestDetails from "./viewTestDetails";
import EditTest from "./editTest";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import { getCategorySlice } from "../../../store/slices/categorySlice";
import { getLiscodeSlice } from "../../../store/slices/liscodeSlice";
import CardPagination from "../../common/pagination/cardPagination";
import { getTestSampleTypeSlice } from "../../../store/slices/testSampleTypeSlice";
import { getAllTestmethod } from "../../../store/slices/testMethodSlice";
const ClinicTestMasters = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewAllclinicTestMasterTests, setViewAllclinicTestMasterTests] =
    useState(false);
  const [viewTestDetails, setViewTestDetails] = useState(false);
  const { userInfo, token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { categories } = useSelector((state) => state.category);
  const { liscodes } = useSelector((state) => state.liscode);
  const { testSampleType } = useSelector((state) => state.testSampleType);
  const { testMethod } = useSelector((state) => state.testMethod);
  
  const initialState = {
    id: "",
    testName: "",
    category: "",
    categoryName: "",
    low_range: "",
    high_range: "",
    mlow_range: "",
    mhigh_range: "",
    flow_range: "",
    fhigh_range: "",
    ilow_range: "",
    ihigh_range: "",
    reference_range_details: "",
    units: "",
    pt_price: "",
    client_price: "",
    tax: "",
    tat: "",
    department: "",
    lisCode: "",
    lisCodeName: "",
    status: "Active",
    analyzerType: "",
    testSampleType: "",
    testSampleTypeName: "",
    testMethod: "",
    testMethodName: "",
  };
  const [inputError, setInputError] = useState({
    text: false,
    onlyNumber: false,
  });
  const [testFormData, setTestFormData] = useState(initialState);
  const [editTestModal, setEditTestModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const showMessageAndReset = ShowTostifyMessageAndReset();
  const {
    clinicTestMasterTestInfo,
    searchMessage,
    editClinicTestMasterTestByTestIdSuccessMessage,
    editClinicTestMasterTestByTestIdErrorMessage,
    clinicTestMasterByClinicId,
    deleteTestinClinicTestMasterSuccessMessage,
    deleteTestinClinicTestMasterErrorMessage,
    loading,
    currentPage,
    totalPages,
    totalCount,
    limit,
  } = useSelector((state) => state.clinicTestMaster);
  const clinicId = clinicInfo?.[0]?.clinicId;
  useEffect(() => {
    dispatch(getCategorySlice({ token }));
    dispatch(getLiscodeSlice({ token }));
    dispatch(getTestSampleTypeSlice({ token }));
    dispatch(getAllTestmethod({ token }));
  }, [dispatch, viewAllclinicTestMasterTests, deleteModal, token]);
  useEffect(() => {
    dispatch(getClinicTestMasterByClinicId({ clinicId, token }));
  }, [
    dispatch,
    viewAllclinicTestMasterTests,
    deleteModal,
    userInfo,
    clinicId,
    token,
  ]);
  // useEffect(() => {
  //   dispatch(getCategorySlice({ token }));
  //   dispatch(getLiscodeSlice({ token }));
  // }, [dispatch, token]);

  // useEffect(() => {
  //   dispatch(
  //     getClinicTestMasterByClinicId({
  //       clinicId,
  //       searchQuery: searchValue,
  //       currentPage,
  //       limit,
  //       token,
  //     }),
  //   );
  // }, [
  //   dispatch,
  //   clinicId,
  //   token,
  //   currentPage,
  //   limit,
  //   viewAllclinicTestMasterTests,
  //   deleteModal,
  // ]);

  const handlePageChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleLimitChange = (newLimit) => {
    dispatch(setPageLimit(newLimit));
  };

  useEffect(() => {
    showMessageAndReset(
      editClinicTestMasterTestByTestIdSuccessMessage,
      showToastifySuccess,
      resetEditClinicTestMasterTestByTestIdMessage,
    );
    showMessageAndReset(
      deleteTestinClinicTestMasterSuccessMessage,
      showToastifySuccess,
      resetDeleteTestinClinicTestMasterMessage,
    );
    showMessageAndReset(
      editClinicTestMasterTestByTestIdErrorMessage,
      showToastifyError,
      resetEditClinicTestMasterTestByTestIdMessage,
    );
    showMessageAndReset(
      deleteTestinClinicTestMasterErrorMessage,
      showToastifyError,
      resetDeleteTestinClinicTestMasterMessage,
    );
  }, [
    editClinicTestMasterTestByTestIdSuccessMessage,
    editClinicTestMasterTestByTestIdErrorMessage,
    deleteTestinClinicTestMasterSuccessMessage,
    deleteTestinClinicTestMasterErrorMessage,
    dispatch,
    clinicInfo,
    showMessageAndReset,
  ]);

  const handleConfirmDelete = async (e) => {
    e.preventDefault();
    try {
      dispatch(
        deleteTestFromClinicTestMaster({
          clinicId,
          clinicTestMasterId: clinicTestMasterByClinicId[0]?._id,
          testId: testFormData.id,
          token,
        }),
      );
      dispatch(getClinicTestMasterByClinicId({ clinicId, token }));
      setDeleteModal(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteTest = (value) => {
    setTestFormData({
      ...testFormData,
      id: value?._id,
      testName: value?.testName,
    });
    setDeleteModal(true);
  };

  const handleViewTestDetails = async (clinic, value) => {
    await dispatch(
      getClinicTestMasterTestDetailsByTestId({
        clinicId: clinic.clinicId?._id,
        testId: value?._id,
        token,
      }),
    );
    setViewAllclinicTestMasterTests(false);
    setViewTestDetails(true);
  };

  const handleViewTestDetailsModal = () => {
    setViewTestDetails(false);
    setViewAllclinicTestMasterTests(true);
  };

  const handleEditTestDetails = (value) => {
    setEditTestModal(true);
    setTestFormData({
      id: value?._id,
      testName: value?.testName,
      category: value?.category?._id,
      categoryName: value?.category?.categoryName,
      low_range: value?.low_range,
      high_range: value?.high_range,
      mlow_range: value?.mlow_range,
      mhigh_range: value?.mhigh_range,
      flow_range: value?.flow_range,
      fhigh_range: value?.fhigh_range,
      ilow_range: value?.ilow_range,
      ihigh_range: value?.ihigh_range,
      reference_range_details: value?.reference_range_details,
      units: value?.units,
      pt_price: value?.pt_price,
      client_price: value?.client_price,
      tax: value?.tax,
      tat: value?.tat,
      department: value?.department,
      lisCode: value?.lisCode?._id,
      lisCodeName: value?.lisCode?.codeName,
      status: value?.status,
      analyzerType: value?.analyzerType,
      testSampleType: value?.testSampleType?._id,
      testSampleTypeName: value?.testSampleType?.name,
      testMethod: value?.testMethod?._id,
      testMethodName: value?.testMethod?.name,
    });
    setViewAllclinicTestMasterTests(false);
  };

  const handleSetTestFormData = (e, names) => {
    if (names === "category") {
      setTestFormData({
        ...testFormData,
        category: e.value,
        categoryName: e.label,
      });
    } else if (names === "liscode") {
      setTestFormData({
        ...testFormData,
        lisCode: e.value,
        lisCodeName: e.label,
      });
    } else if (names === "testSampleType") {
      setTestFormData({
        ...testFormData,
        testSampleType: e.value,
        testSampleTypeName: e.label,
      });
    } else if (names === "testMethod") {
      setTestFormData({
        ...testFormData,
        testMethod: e.value,
        testMethodName: e.label,
      });
    } else {
      const { name, value } = e.target;
      setTestFormData({ ...testFormData, [name]: value });
    }
  };

  const handleSubmitUpdateTestDetails = async (e) => {
    e.preventDefault();
    const { text, onlyNumber } = inputError;
    if (text || onlyNumber) return;
    await dispatch(
      editClinicTestMasterTestByTestId({
        clinicId,
        clinicTestMasterId: clinicTestMasterByClinicId[0]?._id,
        testId: testFormData?.id,
        testDetails: testFormData,
        updatedBy: clinicInfo[0]?._id,
        token,
      }),
    );
    setEditTestModal(false);
    await dispatch(
      getClinicTestMasterByClinicId({ clinicId, status: ["Active"], token }),
    );
    setViewAllclinicTestMasterTests(true);
    setViewTestDetails(false);
  };

  const handleEditTestModal = () => {
    setEditTestModal(false);
    setViewAllclinicTestMasterTests(true);
    setViewTestDetails(false);
  };

  // const handleSearch = (e) => {
  //   setSearchValue(e.target.value);
  //   dispatch(
  //     getClinicTestMasterByClinicId({
  //       clinicId,
  //       searchQuery: e.target.value,
  //       token,
  //     }),
  //   );
  // };
  const handleSearch = (e) => {
    const val = e.target.value;
    setSearchValue(val);
    dispatch(setCurrentPage(1)); // Search pe page 1 reset karein
    dispatch(
      getClinicTestMasterByClinicId({
        clinicId,
        searchQuery: val,
        currentPage: 1,
        limit,
        token,
      }),
    );
  };

  return (
    <>
      <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
        <div className="input-group search-area ms-auto d-inline-flex me-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search here"
            value={searchValue}
            onChange={handleSearch}
          />
          <div className="input-group-append">
            <button type="button" className="input-group-text">
              <FaSearch className="flaticon-381-search-2" />
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <div
          className="d-flex flex-column justify-content-center align-items-center w-100"
          style={{ height: "300px" }}
        >
          <div className="spinner-border text-primary mb-3" role="status"></div>
          <p className="mb-0 fw-semibold text-primary">Loading data...</p>
        </div>
      ) : clinicTestMasterByClinicId &&
        clinicTestMasterByClinicId[0]?.tests?.length > 0 ? (
        <>
          <div className="row">
            {clinicTestMasterByClinicId[0]?.tests?.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-sm-1" key={index}>
                <div className="card project-boxed">
                  <div
                    className={classNames(
                      styles.titel,
                      "card-header",
                      "align-items-start",
                    )}
                  >
                    <div className={styles.titelWrapper}>
                      <RiProfileLine />
                      <h6 className="fs-18 font-w500">
                        <Link to={"#"} className="text-black user-name">
                          {item?.testName}
                        </Link>
                      </h6>
                    </div>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        as="div"
                        className="btn-link i-false"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                            stroke="#342E59"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                            stroke="#342E59"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                            stroke="#342E59"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu align={"end"}>
                        <Dropdown.Item
                          onClick={() => handleEditTestDetails(item)}
                        >
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                          className="text-danger"
                          onClick={() => handleDeleteTest(item)}
                        >
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="card-body p-0 pb-3">
                    <ul className="list-group list-group-flush">
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <b className={styles.clinicName}>Test Name:</b>
                        <span className="text-black ms-2">
                          {item?.testName}
                        </span>
                      </li>
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <b className={styles.clinicName}>Client Price:</b>
                        <span className="text-black ms-2">
                          {item?.client_price || "N/A"}
                        </span>
                      </li>
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <b className={styles.clinicName}>Patient Price:</b>

                        <span className="text-black ms-2">
                          {item?.pt_price || "N/A"}
                        </span>
                      </li>
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <b className={styles.clinicName}>Category:</b>
                        <span className="text-black ms-2">
                          {item?.category?.categoryName || "N/A"}
                        </span>
                      </li>
                      <div
                        className={styles.viewMoreWrapper}
                        onClick={() =>
                          handleViewTestDetails(
                            clinicTestMasterByClinicId[0],
                            item,
                          )
                        }
                      >
                        <p>
                          View Tests Details <FaChevronRight />
                        </p>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 4. Pagination Component Implementation */}
          <CardPagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            limit={limit}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </>
      ) : (
        <h5 className="text-center mt-5">{searchMessage}</h5>
      )}

      {/* view test details */}
      <ViewTestDetails
        viewTestDetails={viewTestDetails}
        setViewTestDetails={setViewTestDetails}
        clinicTestMasterTestInfo={clinicTestMasterTestInfo}
        handleViewTestDetailsModal={handleViewTestDetailsModal}
        handleDeleteTest={handleDeleteTest}
        handleEditTestDetails={handleEditTestDetails}
      />

      {/* edit test detais */}
      <EditTest
        testFormData={testFormData}
        editTestModal={editTestModal}
        categories={categories}
        setEditTestModal={setEditTestModal}
        handleSetTestFormData={handleSetTestFormData}
        handleSubmitUpdateTestDetails={handleSubmitUpdateTestDetails}
        handleEditTestModal={handleEditTestModal}
        liscodes={liscodes}
        setInputTextError={setInputError}
        testSampleType={testSampleType}
        testMethod={testMethod}
      />

      {/* delete Modal */}
      <Modal
        centered
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        size={"md"}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Confirm Delete
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete the Test Master{" "}
            <strong className="text-dark">{testFormData?.testName}</strong>?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ClinicTestMasters;
